import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class ToggleService {
    private _isToggled = new BehaviorSubject<boolean>(false);

    public toggle() {
        this._isToggled.next(!this._isToggled.value);
    }

    public toggled(): Observable<boolean> {
        return this._isToggled.asObservable();
    }
}
